<script setup>
import { defineProps, ref, computed } from 'vue'
import DocSection from '@/components/Docs/Section.vue'
import CodeBlock from '@/components/Docs/CodeBlock.vue'
import StringParam from '@/components/Docs/Parameters/StringParam.vue'
import EndpointBlock from '@/components/Docs/EndpointBlock.vue'

defineProps({ anchor: String })

let request_slug = ref("webscout_geo")
let request_artifact = ref("mmdb")

let get_query = computed(() => {
  return `/enrichments/${request_slug.value}/download/${request_artifact.value}`
})

let dynamic_title = computed(() => {
  return `/enrichments/${request_slug.value}/download/${request_artifact.value}`
})
</script>

<template>
  <doc-section title="Enrichment download" :anchor="anchor">
    <template v-slot:left>
      <div class="mb-5">
        <p>
          Downloads a bulk dataset artifact for an enrichment your organization is
          granted. The endpoint streams the file as an attachment (with a
          timestamped filename) rather than returning JSON.
        </p>
        <p>
          Access requires either the <code>download</code> capability on a granted
          enrichment, or a connected bring-your-own credential for it. Discover the
          available enrichment slugs and their artifacts from the
          <code>/enrichments</code> catalog. Unknown slug or artifact returns
          <code>404</code>; a dataset you are not permitted to download returns
          <code>403</code>.
        </p>
      </div>

      <div class="mb-5">
        <h4 class="mb-4">Request parameters</h4>

        <StringParam class="mb-3" name="Slug" :required="true"
          description="The enrichment slug (path parameter)"
          type="string" :value="request_slug" @value="(v) => request_slug = v" />

        <StringParam class="mb-3" name="Artifact" :required="true"
          description="The artifact identifier to download (path parameter)"
          type="string" :value="request_artifact" @value="(v) => request_artifact = v" />
      </div>
    </template>

    <template v-slot:right>
      <endpoint-block
        :title="dynamic_title"
        method="GET"
        name="Enrichment Download"
        :query="get_query"
        :download="true"
      />

      <code-block title="Download, curl" method="GET" text>
        curl -L "https://api.webscout.io/enrichments/webscout_geo/download/mmdb?apikey={YOUR_APIKEY}" -o webscout_geo.mmdb
      </code-block>
    </template>
  </doc-section>
</template>
